import { gql } from '@apollo/client';

export const getOrderById = (output: string) => gql`
  query getOrderById($id: String!) {
    order(id: $id) {
      ${output}
    }
  }
`; 
